<template>
  <div v-if="review">
    <v-card color="teal lighten-5" flat>
      <v-card-text>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-chip small :color="statusColor()">
            {{ review.recommendation }}
          </v-chip>
        </div>

        <!-- <AuthorDetails class="my-3" :author="review.reviewer" /> -->

        <section class="mt-2">
          <strong>
            Review
            <span v-if="review.reviewIndex">#{{ review.reviewIndex }}</span>
          </strong>
          <div class="abstract" v-html="review.review"></div>
          <!-- <strong>Private Comment</strong>
          <div class="abstract" v-html="review.privateReview"></div> -->
          <div class="mb-5" v-if="review.reviewFile">
            <div class="d-flex mb-2">
              <strong>Reviewer attachment</strong>
              <v-spacer></v-spacer>
              <v-btn
                x-small
                rounded
                outlined
                color="teal"
                class="mr-1 mb-1"
                :href="review.reviewFile.location"
              >
                Download File
              </v-btn>
            </div>
            <v-divider></v-divider>
          </div>
        </section>

        <div class="d-flex" style="line-height: 1.2">
          <small>
            By {{ review.reviewer.title }}
            {{ review.reviewer.firstName }}
            {{ review.reviewer.lastName }}
            <u v-if="review.reviewer.institution"
              >of {{ review.reviewer.institution }}</u
            >
            <u v-if="review.reviewer.specialization"
              >&nbsp;specializing in {{ review.reviewer.specialization }}</u
            >
            on
            {{ formatDate(review.createdAt) }}
          </small>
          <!-- <v-spacer></v-spacer>
          <small>Updated: {{ formatDate(review.updatedAt) }}</small> -->
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { formatDate } from "../../../tools/format";

export default {
  props: ["review"],

  data: () => ({
    cancelling: false,
  }),

  methods: {
    formatDate,
    statusColor() {
      switch (this.review.recommendation) {
        case "ACCEPT":
          return "green white--text";

        case "REJECT":
          return "red white--text";

        case "MINOR-REVISION":
          return "blue white--text";

        case "MAJOR-REVISION":
          return "orange white--text";

        default:
          "";
          break;
      }
    },
  },
};
</script>

<style>
</style>